import { Injectable } from '@angular/core';
import { AngularFireDatabase } from 'angularfire2/database';
import { AngularFirestore } from 'angularfire2/firestore';
import {HttpClient, HttpHeaders} from '@angular/common/http';

@Injectable()
export class CatalogosService {

  constructor(private afDB:AngularFireDatabase, private afs:AngularFirestore,private http:HttpClient,) { }

  public eliinarViajes(idSer){
      return this.afs.collection('viajes',ref=>ref.where('idConfirmacion','==',idSer))
  }
  public noAsig(servicio){
    return this.afs.collection('servicios').doc(servicio).update({estatus:'No Asignado'});
}

public borraTodo(idConf){
    return this.afs.collection('servicios',ref=>ref.where('confirmacion','==',idConf)).snapshotChanges().take(1).subscribe(res=>{
        console.log(res)
        res.forEach(viaje=>{
            this.afs.collection('servicios').doc(viaje.payload.doc.id).delete();
        })

    })
}
public elimViaje(idConf){
    return this.afs.collection('viajes',ref=>ref.where('idConfirmacion','==',idConf)).snapshotChanges().take(1).subscribe(res=>{
        console.log(res)
        res.forEach(viaje=>{
            this.afs.collection('viajes').doc(viaje.payload.doc.id).delete();
        })

    })
}



  // Obtiene los estatus posibles de los clientes
  public obtenerEstatusDeCliente(){
    return this.afDB.list('catalogos/estatusDeCliente');
  }

  // Obtiene los estados de la república mexicana
  public obtenerEstados(){
    return this.afDB.list('catalogos/estados');
  }

  public obtenerLimiteDisponibilidad(){
    return this.afDB.object('catalogos/limiteDisponibilidad');
  }

  // Obtiene la lista de los paises disponibles
  public obtenerPaises(){
    return this.afDB.list('catalogos/paises');
  }
   // Obtiene la lista de los dias de la semana
   public obtenerDiasDeDescanso(){
    return this.afDB.list('catalogos/diasDeLaSemana');
  }

  // Obtiene la lista de los roles de contacto disponibles para los contactos de los clientes
  public obtenerRolesDeContacto(){
    return this.afDB.list('catalogos/rolesDeContacto');
  }

  // Obtiene los departamentos de Recursos Humanos dentro de la compañía
  public obtenerDepartamentos(){
    return this.afDB.list('catalogos/departamentos');
  }
    public obtenerPuestos(){
        return this.afDB.list('catalogos/puestos');
    }
    public obtenerRegiones(){
      return this.afDB.list('catalogos/regiones');
  }
  public obtenerTipoOperadorYUnidad(){
    return this.afDB.list('catalogos/tipoOperadorYUnidad');
}
  // Obtiene los roles de usuario disponibles en el sistema
  public obtenerRolesDeUsuario(){
    return this.afDB.list('catalogos/rolesDeUsuario');
  }

  // Obtiene los estados civiles
  public obtenerEstadosCiviles(){
    return this.afDB.list('catalogos/estadosCiviles');
  }

  // Obtiene los tipos de sangre
  public obtenerTiposDeSangre(){
    return this.afDB.list('catalogos/tiposDeSangre');
  }

  // Obtener Antecedentes Penales
  public obtenerAntecedentesPenales(){
    return this.afDB.list('catalogos/antecedentesPenales');
  }

  // Obtener Grados de estudio
  public obtenerGradosDeEstudio(){
    return this.afDB.list('catalogos/gradosDeEstudio');
  }

  // Obtener Idiomas
  public obtenerIdiomas(){
    return this.afDB.list('catalogos/idiomas');
  }
  // Obtener los tipos de licencias para operador
  public obtenerTiposDeLicencia(){
    return this.afDB.list('catalogos/tiposDeLicencia');
  }

  // Obtener los estatus de personal
  public obtenerEstatusDePersonal(){
    return this.afDB.list('catalogos/estatusDePersonal');
  }

  // Obtener parentescos para contactos de emergencia
  public obtenerparentescos(){
    return this.afDB.list('catalogos/parentescos');
  }

  // Obtiene los tipos de venta disponibles para las cotizaciones
  public obtenerTiposDeVenta(){
    return this.afDB.list('catalogos/tiposDeVenta');
  }

  // Obtiene los procesos de pago
  public obtenerProcesosDePago(){
    return this.afDB.list('catalogos/procesosDePago');
  }

  // Obtiene los estatus de pago
  public obtenerEstatusDePago(){
    return this.afDB.list('catalogos/estatusDePago');
  }

  // Obtiene las formas de pago
  public obtenerFormasDePago(){
    return this.afDB.list('catalogos/formasDePago');
  }
  // Obtiene las formas de pago CDG
  public obtenerFormasDePagoCDG(){
    return this.afDB.list('catalogos/formasDePagoCargasDeGasolina');
  }

  // Obtiene los métodos de cotización para las ventas
  public obtenerMetodosDeCotizacion(){
    return this.afDB.list('catalogos/metodosDeCotizacion');
  }
    public obtenerDeDondeLLego(){
        return this.afDB.list('catalogos/deDondeSeEntero');
    }


  // Obtiene los tipos de viaje
  public obtenerTiposDeViaje(){
    return this.afDB.list('catalogos/tiposDeViaje');
  }

  // Obtiene las oficinas de origen de los servicios
  public obtenerOficinasDeOrigen(){
    return this.afDB.list('catalogos/oficinasDeOrigen');
  }

  public proveedoresDeGasolina(){
     return this.afs.collection('proveedoresDeGasolina')
  }
  public obtenerFormasDePagoPorProveedor(proveedor){
      return this.afs.collection('proveedoresDeGasolina').doc(proveedor)
  }

    public obtenerTiposDeCombustible(){
        return this.afDB.list('catalogos/tiposDeCombustible')
    }
    public obtenerTiposDeUnidad(){
        return this.afDB.list('catalogos/tiposDeUnidad')
    }

    public obtenerRutasCorpSchool(){
        const headers = new HttpHeaders({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'});

        const body = '';
        return this.http.post('https://operacion.trosten.com/corp-school/php/admin/Rutas/getRutas.php', body,{headers});
    }

}



// WEBPACK FOOTER //
// E:/Github/trosten/trosten-web-app/src/app/services/catalogos.service.ts